export default {
  id: 'teams_leaderboard_individual',
  title: 'Leaderboard - Individual',
  type: 'Direct',
  description: 'Message the overall standing of the leaderboard to the participants.',
  body: `<div>
    <div style="padding-bottom: 10px">[[INPUT_PRE_LEADERBOARD_TEXT]]</div>
    <p style="font-size: 16px; padding-bottom: 10px"><strong>Leaderboard</strong></p>
    <table style="border: 0; mso-table-lspace: 0pt; mso-table-rspace: 0pt; overflow: hidden; background-color:rgba(0, 0, 0, 0);" cellpadding="0" cellspacing="0" width="100%">
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🥇</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_NAME}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_POINTS}} points</td>
      </tr>
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🥈</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_NAME}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_POINTS}} points</td>
      </tr>
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">🥉</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_NAME}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_POINTS}} points</td>
      </tr>
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">...</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);"></td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);"></td>
      </tr>
      <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_POSITION}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{FIRST_NAME}} {{LAST_NAME}}</td>
        <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_POINTS}} points</td>
      </tr>
    </table>
    <div style="padding-top: 15px">[[INPUT_POST_LEADERBOARD_TEXT]]</div>
  </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
  inputs: {
    INPUT_PRE_LEADERBOARD_TEXT: {
      label: 'Text before leaderboard',
      placeholder: 'Hi All ...',
      defaultValue: '<p>Hi All,</p><p>The current standing of the leaderboard is the following</p>',
      type: 'HTML'
    },
    INPUT_POST_LEADERBOARD_TEXT: {
      label: 'Text after leaderboard',
      placeholder: 'Come back to the platform to earn awesome rewards...',
      defaultValue: '<p>Come back to the platform to earn awesome rewards.<br>{{PLATFORM_LINK}}</p>',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/leaderboardIndividual.js